import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { CompanyInfographicsDto } from "app/pages/sales-intelligence/modules/leads-search/types";
import leadsSearchFiltersI18nKeys from "app/pages/sales-intelligence/modules/leads-search-filters/utils/i18n";
import { formatTaxonomyPathDisplayNames } from "app/pages/sales-intelligence/utils/taxonomy-tree/path";

import { StyledInfoWrapper, StyledText, StyledTitle } from "./styles";

type Props = {
    companyData: CompanyInfographicsDto;
};

const HeaderContent = ({ companyData: { industry, industryTaxonomy, employees, hqCountry } }: Props) => {
    // Which classification the header speaks (ADR-0013): the backend serves one or the other, never both.
    const industryTitleKey = industryTaxonomy
        ? leadsSearchFiltersI18nKeys.industryTaxonomyName()
        : "table.sub-table.header.info.industry";
    const industryText = industryTaxonomy ? formatTaxonomyPathDisplayNames(industryTaxonomy.path) : industry;

    return (
        <>
            {industryText ? (
                <StyledInfoWrapper data-automation="industry-info">
                    <I18n
                        translatable={{ key: industryTitleKey }}
                        element={StyledTitle}
                    />
                    <StyledText>{industryText}</StyledText>
                </StyledInfoWrapper>
            ) : null}

            <StyledInfoWrapper data-automation="hq-country-info">
                <I18n
                    translatable={{ key: "table.sub-table.header.info.hq-country" }}
                    element={StyledTitle}
                />
                <StyledText>{hqCountry}</StyledText>
            </StyledInfoWrapper>

            <StyledInfoWrapper data-automation="employee-info">
                <I18n
                    translatable={{ key: "table.sub-table.header.info.employee" }}
                    element={StyledTitle}
                />
                <StyledText>{employees}</StyledText>
            </StyledInfoWrapper>
        </>
    );
};

export default HeaderContent;
